import React, { useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { LuMenu as Menu, LuX as X } from 'react-icons/lu';

const Navbar = ({ onScheduleCall }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { scrollY } = useScroll();
  
  const navBackground = useTransform(
    scrollY,
    [0, 100],
    ['rgba(0, 0, 0, 0)', 'rgba(0, 0, 0, 0.95)']
  );
  
  const navShadow = useTransform(
    scrollY,
    [0, 100],
    ['0px 0px 0px rgba(0, 0, 0, 0)', '0px 4px 20px rgba(0, 0, 0, 0.5)']
  );

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      style={{
        backgroundColor: navBackground,
        boxShadow: navShadow,
      }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'backdrop-blur-md py-3 md:py-4 border-b border-white/10' : 'py-4 md:py-6'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between">
        <motion.a
          href="#"
          className="flex items-center group"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <img
            src="https://cdn.prod.website-files.com/62714322a659c56310ea38fe/627cac93404068f059e46598_Logo_White.png"
            alt="Arabica Design Studio"
            className="h-7 md:h-8 w-auto"
            style={{ maxWidth: '180px' }}
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <div className="hidden items-center gap-3">
            <div className="w-7 h-7 md:w-8 md:h-8 bg-white rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-shadow">
              <span className="text-black font-bold text-base md:text-lg">A</span>
            </div>
            <span className="font-bold text-base md:text-lg text-white">
              Arabica Design Studio
            </span>
          </div>
        </motion.a>

        <div className="hidden md:block">
          <motion.button
            className="btn-primary magnetic-button font-bold"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onScheduleCall}
          >
            Book Your Strategy Call
          </motion.button>
        </div>

        <motion.button
          className="md:hidden p-2 rounded-lg bg-white/10 backdrop-blur-sm"
          whileTap={{ scale: 0.95 }}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? (
            <X className="text-white w-5 h-5" />
          ) : (
            <Menu className="text-white w-5 h-5" />
          )}
        </motion.button>
      </div>

      {isMobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          className="md:hidden bg-black border-t border-white/10 shadow-lg"
        >
          <div className="container mx-auto px-4 py-6">
            <button
              className="w-full btn-primary font-bold text-sm"
              onClick={() => {
                onScheduleCall();
                setIsMobileMenuOpen(false);
              }}
            >
              Book Your Strategy Call
            </button>
          </div>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar;